import React, { useEffect } from 'react';
import '../styles/OrderConfirmation.scss';
import View from '../components/View';
import _ from 'lodash';
import CardCheckout from '../components/CardCheckout';
import MobileMenuBottom from '../components/MobileBottomMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from '../selectors/Order';
import { fetchOrders } from '../actions/Order';
import { useQuery } from '../helpers/functions';

const OrderConfirmation = () => {
  const orders = useSelector(getOrders);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);
  const query = useQuery();
  const orderNumber = parseInt(query.get('orderNumber') || '0', 10);
  const order = orders?.filter(o => o.order_number === orderNumber);
  const first = _.first(order);
  return (
    <View>
      <div className="confirmation">
        <div className="container">
          <div className="confirmation__title">
            <h4>Order Confirmed</h4>
          </div>
          <div className="row confirmation__info pb-5 d-flex">
            <div className="col-lg-2 col-md-12 confirmation__info__id">
              <p className="medium-grey-text pb-3">Order Number</p>
              <p className="medium-grey-text pb-3">{orderNumber}</p>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 confirmation__info__datet pb-3">
              <p className="medium-grey-text pb-3">Order Date</p>
              <p>{first?.date_ordered}</p>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 confirmation__info__datet pb-3">
              <p className="medium-grey-text pb-3">Delivery Date</p>
              <p>{first?.delivery_date}</p>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 confirmation__info__total pb-3">
              <p className="medium-grey-text pb-3">Order Total</p>
              <p>£000.00</p>
            </div>
          </div>
          <div className="confirmation__line mb-5"></div>
          <div className="confirmation-order pb-3">
            <p>Your Order</p>
          </div>
          {order.map((o, i) => <CardCheckout
              key={i}
              imageCode={o.product_sku}
              quality={o.product_desc}
              category={o.order_status}
              linePrice={o.line_value}
              itemPrice={o.line_price}
              length={o.LENGTH}
              width={o.WIDTH}
              quantity={o.qty_ordered}
              hideAction
              reference={o.line_reference}
          />)}
        </div>
        <div className="order-total offset-lg-8">
          <h4>Order Total</h4>
          <div className="order-total__column">
            <div className="order-total__column__subtotal d-flex pb-3">
              <p>Subtotal Excl VAT</p>
              <p>£000.00</p>
            </div>
            <div className="order-total__column__vat d-flex pb-3">
              <p>VAT (20%)</p>
              <p>£00.00</p>
            </div>
            <div className="order-total__column__total d-flex pb-3">
              <p>Total</p>
              <p>£000.00</p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-mobile-nav">
        <MobileMenuBottom />
      </div>
    </View>
  );
};

export default OrderConfirmation;
